// extracted by mini-css-extract-plugin
export default {"remind-text":"index-module__remind-text___KsMxL","remindText":"index-module__remind-text___KsMxL"};